var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M13 18c-.081 0-8.14-.006-10.172-.55a3.24 3.24 0 0 1-2.292-2.266A33.623 33.623 0 0 1 0 9a33.728 33.728 0 0 1 .536-6.182A3.309 3.309 0 0 1 2.826.531C4.838.006 12.918 0 13 0s8.161.006 10.172.552a3.238 3.238 0 0 1 2.292 2.266A31.556 31.556 0 0 1 26 9.022a33.745 33.745 0 0 1-.535 6.183 3.242 3.242 0 0 1-2.292 2.266C21.162 17.994 13.081 18 13 18M10.409 5.147v7.707L17.176 9z",
    "data-name": "Subtraction 1"
  })));
};
export default SvgYoutube;